import { type Static, type StaticEncode, Type } from '@sinclair/typebox';
import {
  HexColorSchema,
  ImageSizesSchema,
  MongoIdStringSchema,
  MongooseObjectIdOrStringSchema,
  MongooseRefSchema,
  TransformedRefToString,
  UrlSchema,
} from './common.dto.js';
import { PodcastEpisodeDTOSchema } from './podcast-episode.dto.js';

export const SpotlightPreviewDTOSchema = Type.Object({
  description: Type.Optional(Type.String({ maxLength: 300 })),
  favicon: Type.Optional(UrlSchema),
  imageSizes: Type.Optional(ImageSizesSchema),
  siteName: Type.Optional(Type.String({ maxLength: 100 })),
  title: Type.Optional(Type.String({ maxLength: 200 })),
});

export type SpotlightPreviewDTO = Static<typeof SpotlightPreviewDTOSchema>;

export const SpotlightDTOSchema = Type.Object({
  _id: MongooseObjectIdOrStringSchema,
  createdAt: Type.Optional(Type.Any()),
  end: Type.Number(),
  item: TransformedRefToString(MongooseRefSchema(PodcastEpisodeDTOSchema)),
  start: Type.Number({ minimum: 0 }),
  type: Type.Union([Type.Literal('link')]),
  uiConfig: Type.Object({
    name: Type.String({ maxLength: 100 }),
    backgroundColor: HexColorSchema,
  }),
  updatedAt: Type.Optional(Type.Any()),
});
export type SpotlightDTO = StaticEncode<typeof SpotlightDTOSchema>;

export const SpotlightLinkDTOSchema = Type.Composite([
  SpotlightDTOSchema,
  Type.Object({
    preview: Type.Optional(SpotlightPreviewDTOSchema),
    url: UrlSchema,
    type: Type.Literal('link'),
  }),
]);
export type SpotlightLinkEncodedDTO = StaticEncode<typeof SpotlightLinkDTOSchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const ListSpotlightsReplychema = Type.Object({ links: Type.Array(SpotlightLinkDTOSchema) });
export type ListSpotlightsReply = StaticEncode<typeof ListSpotlightsReplychema>;

export const UpdateSpotlightsBodySchema = Type.Object({
  updates: Type.Array(
    Type.Object({
      _id: Type.String(),
      url: SpotlightLinkDTOSchema.properties.url,
      end: SpotlightLinkDTOSchema.properties.end,
      start: SpotlightLinkDTOSchema.properties.start,
      uiConfig: SpotlightLinkDTOSchema.properties.uiConfig,
      item: Type.String(),
    }),
  ),
  create: Type.Array(
    Type.Object({
      _id: Type.String(),
      url: SpotlightLinkDTOSchema.properties.url,
      end: SpotlightLinkDTOSchema.properties.end,
      start: SpotlightLinkDTOSchema.properties.start,
      uiConfig: SpotlightLinkDTOSchema.properties.uiConfig,
      item: Type.String(),
    }),
  ),
  delete: Type.Array(MongoIdStringSchema),
});

export type UpdateSpotlightsBody = StaticEncode<typeof UpdateSpotlightsBodySchema>;
